<app-page-header
    title="Calendario de Facturación"
    mobileTitle="Periodos"
    icon="fas fa-calendar-alt"
    [hasOptions]="appSettings.isMobile() && (perm.hasCurrentAction('PERIOD_AUTOMATE') || perm.hasCurrentAction('PERIOD_OPEN_CLOSE'))">
    <div headerOptions>
        @if (perm.hasCurrentAction('PERIOD_AUTOMATE')) {
        <a class="dropdown-item" (click)="openAutomatize()">
            <i class="fas fa-robot fa-fw me-2 text-primary"></i> Automatizar
        </a>
        }
        @if (!openPeriod() && perm.hasCurrentAction('PERIOD_OPEN_CLOSE')) {
        <a class="dropdown-item" (click)="openNextMonth()">
            <i class="fas fa-unlock fa-fw me-2 text-success"></i> Abrir siguiente mes
        </a>
        }
    </div>
    @if (appSettings.isMobile() && !openPeriod() && perm.hasCurrentAction('PERIOD_OPEN_CLOSE')) {
        <button headerExtra type="button" class="btn btn-outline-success btn-xs" (click)="openNextMonth()" [disabled]="isLoading()">
            Abrir
        </button>
    }
</app-page-header>
@if (!appSettings.isMobile() && perm.hasCurrentAction('PERIOD_AUTOMATE')) {
<div class="d-flex justify-content-end mb-3">
    <a href="javascript:;" (click)="openAutomatize()"
        class="text-decoration-none text-dark text-opacity-75 fw-bold">
        <i class="fas fa-robot fa-fw me-1 text-dark text-opacity-50"></i> Automatizar
    </a>
</div>
}

@if (openPeriod(); as open) {
    <div class="alert alert-success border-0 shadow-sm d-flex align-items-center mb-3">
        <i class="fas fa-unlock me-2"></i>
        <div>
            <strong>Periodo en curso: {{ periodLabel(open) }} — {{ getMonthName(open.period) }}.</strong>
            <span class="d-block small mb-0">Las transferencias, altas y bajas nuevas se asignan a este periodo. La fecha real de cada solicitud se conserva.</span>
        </div>
    </div>
} @else if (nextToOpen(); as next) {
    <div class="alert alert-warning border-0 shadow-sm d-flex align-items-center mb-3">
        <i class="fas fa-lock me-2"></i>
        <div>
            <strong>No hay periodo abierto.</strong>
            <span class="d-block small mb-0">El siguiente a abrir es {{ periodLabel(next) }} — {{ getMonthName(next.period) }}. Sin un periodo en curso no se pueden registrar transferencias.</span>
        </div>
    </div>
} @else if (!isLoading()) {
    <div class="alert alert-secondary border-0 shadow-sm mb-3">
        <i class="fas fa-info-circle me-2"></i>
        No hay periodo abierto. Al cerrar se crea solo el mes siguiente. Puedes abrir el siguiente mes ahora.
    </div>
}

<div [class.panel]="!appSettings.isMobile()" [class.p-3]="!appSettings.isMobile()"
     [class.mb-3]="true" [class.border-0]="!appSettings.isMobile()" [class.shadow-sm]="!appSettings.isMobile()"
     [class.mobile-requests-container]="appSettings.isMobile()">
    <div class="row align-items-end g-3">
        <div class="col-6 col-md-3">
            <label class="form-label fw-bold small text-uppercase text-muted">Desde</label>
            <ng-select [items]="periodOptions()"
                bindLabel="displayName"
                bindValue="id"
                [ngModel]="selectedStartId()"
                (ngModelChange)="onStartChange($event)"
                [clearable]="false"
                placeholder="Desde">
            </ng-select>
        </div>
        <div class="col-6 col-md-3">
            <label class="form-label fw-bold small text-uppercase text-muted">Hasta</label>
            <ng-select [items]="endPeriodOptions()"
                bindLabel="displayName"
                bindValue="id"
                [ngModel]="selectedEndId()"
                (ngModelChange)="onEndChange($event)"
                [clearable]="false"
                placeholder="Hasta">
            </ng-select>
        </div>
        @if (!appSettings.isMobile()) {
        <div class="col-md-6 text-end">
            @if (!openPeriod() && perm.hasCurrentAction('PERIOD_OPEN_CLOSE')) {
                <button class="btn btn-outline-success btn-sm" (click)="openNextMonth()" [disabled]="isLoading()">
                    <i class="fas fa-unlock me-1"></i> Abrir siguiente mes
                </button>
            }
        </div>
        }
    </div>
    <div class="mt-3 mobile-list-shell">
        @if (!appSettings.isMobile()) {
        <div class="table-responsive table-data">
            <table class="table table-hover table-sm align-middle">
                <thead>
                    <tr>
                        <th class="text-uppercase fw-bold text-muted">Mes</th>
                        <th class="text-uppercase fw-bold text-muted">Fecha de cierre</th>
                        <th class="text-uppercase fw-bold text-muted text-center">Tipo de cierre</th>
                        <th class="text-uppercase fw-bold text-muted text-center">Estado</th>
                        <th class="text-muted text-center" style="width: 14rem;"><i class="fas fa-cog"></i></th>
                    </tr>
                </thead>
                <tbody>
                    @if (isLoading()) {
                        @for (i of placeholderRows; track $index) {
                            <tr class="placeholder-glow">
                                <td><span class="placeholder placeholder-sm col-8 bg-gray-500"></span></td>
                                <td><span class="placeholder placeholder-sm col-6 bg-gray-500"></span></td>
                                <td class="text-center"><span class="placeholder placeholder-sm col-4 bg-gray-500"></span></td>
                                <td class="text-center"><span class="placeholder placeholder-sm col-5 bg-gray-500"></span></td>
                                <td class="text-center"><span class="placeholder placeholder-sm col-6 bg-gray-500"></span></td>
                            </tr>
                        }
                    } @else if (periods().length === 0) {
                        <tr>
                            <td colspan="5" class="text-center text-muted py-5">
                                No hay periodos en este rango. Ampliá Desde / Hasta.
                            </td>
                        </tr>
                    } @else {
                        @for (period of periods(); track period.id; let i = $index) {
                            @if (isYearStart(period, i)) {
                                <tr>
                                    <td colspan="5" class="fw-bold text-uppercase small text-muted py-2">
                                        {{ period.year }}
                                    </td>
                                </tr>
                            }
                            <tr>
                                <td>
                                    <span class="fw-bold">
                                        {{ period.period | number:'2.0-0' }} - {{ getMonthName(period.period) }}
                                    </span>
                                </td>
                                <td>
                                    @if (closeDate(period); as closed) {
                                        {{ closed | date:'dd/MM/yyyy HH:mm' }}
                                    } @else {
                                        <span class="text-muted">—</span>
                                    }
                                </td>
                                <td class="text-center">
                                    @if (closeModeLabel(period); as mode) {
                                        <span class="badge border"
                                              [class.border-info]="mode === 'Automático'"
                                              [class.text-info]="mode === 'Automático'"
                                              [class.border-secondary]="mode === 'Manual'"
                                              [class.text-secondary]="mode === 'Manual'">
                                            {{ mode }}
                                        </span>
                                    } @else {
                                        <span class="text-muted">—</span>
                                    }
                                </td>
                                <td class="text-center">
                                    <span class="badge border"
                                        [ngClass]="period.statusRef?.style || 'border-secondary text-secondary'">
                                        {{ period.statusRef?.name }}
                                    </span>
                                </td>
                                <td class="text-center">
                                    @if (isNextToOpen(period) && perm.hasCurrentAction('PERIOD_OPEN_CLOSE')) {
                                        <button class="btn btn-outline-success btn-xs"
                                                (click)="openCurrentPeriod(period)"
                                                title="Abrir periodo">
                                            <i class="fas fa-unlock me-1"></i> Abrir
                                        </button>
                                    }
                                    @if (period.statusSlug === 'ACTIVE') {
                                        @if (perm.hasCurrentAction('CHARGES_GENERATE')) {
                                        <button class="btn btn-outline-primary btn-xs me-1"
                                                (click)="generateBilling(period)"
                                                [disabled]="isLoading()"
                                                title="Generar cobranza">
                                            <i class="fas fa-dollar-sign me-1"></i> Cobros
                                        </button>
                                        }
                                        @if (perm.hasCurrentAction('PERIOD_OPEN_CLOSE')) {
                                        <button class="btn btn-outline-danger btn-xs"
                                                (click)="openPreviewDetails(period)"
                                                title="Cerrar periodo">
                                            <i class="fas fa-lock me-1"></i> Cerrar
                                        </button>
                                        }
                                    }
                                </td>
                            </tr>
                        }
                    }
                </tbody>
            </table>
        </div>
        } @else {
        <div class="d-flex justify-content-between align-items-center mb-2 px-1">
            <span class="small text-muted fw-bold text-uppercase">
                REGISTROS @if (!isLoading()) { ({{ periods().length }}) }
            </span>
        </div>
        <div class="mobile-cards-scroll">
            @if (isLoading()) {
                @for (i of placeholderRows; track $index) {
                    <app-list-card [isLoading]="true"></app-list-card>
                }
            } @else {
                @for (period of periods(); track period.id) {
                    <app-list-card>
                        <div cardTitle class="fw-bold text-dark text-truncate">
                            {{ period.period | number:'2.0-0' }} - {{ getMonthName(period.period) }}
                        </div>
                        <div cardBadge>
                            <span class="badge border"
                                [ngClass]="period.statusRef?.style || 'border-secondary text-secondary'">
                                {{ period.statusRef?.name }}
                            </span>
                        </div>
                        <div class="row g-1 text-muted small">
                            <div class="col-7">
                                <span class="text-muted">Cierre</span>
                                <div>
                                    @if (closeDate(period); as closed) {
                                        {{ closed | date:'dd/MM/yyyy HH:mm' }}
                                    } @else { — }
                                </div>
                            </div>
                            <div class="col-5 text-end">
                                <span class="text-muted">Tipo</span>
                                <div>{{ closeModeLabel(period) || '—' }}</div>
                            </div>
                        </div>
                        <div cardExtra>{{ period.year }}</div>
                        <div cardActionsRow>
                            @if (isNextToOpen(period) && perm.hasCurrentAction('PERIOD_OPEN_CLOSE')) {
                                <button type="button" class="btn btn-sm btn-outline-success"
                                        (click)="openCurrentPeriod(period)">
                                    <i class="fas fa-unlock me-1"></i> Abrir
                                </button>
                            }
                            @if (period.statusSlug === 'ACTIVE') {
                                @if (perm.hasCurrentAction('CHARGES_GENERATE')) {
                                <button type="button" class="btn btn-sm btn-outline-primary"
                                        (click)="generateBilling(period)" [disabled]="isLoading()">
                                    <i class="fas fa-dollar-sign me-1"></i> Cobros
                                </button>
                                }
                                @if (perm.hasCurrentAction('PERIOD_OPEN_CLOSE')) {
                                <button type="button" class="btn btn-sm btn-outline-danger"
                                        (click)="openPreviewDetails(period)">
                                    <i class="fas fa-lock me-1"></i> Cerrar
                                </button>
                                }
                            }
                        </div>
                    </app-list-card>
                }
            }
            @if (!isLoading() && periods().length === 0) {
                <div class="card border-0 shadow-sm p-4 text-center my-2">
                    <i class="fas fa-calendar-alt fa-3x text-muted opacity-50 mb-2"></i>
                    <h6 class="text-muted mb-1">Sin periodos</h6>
                    <small class="text-muted">Ampliá Desde / Hasta.</small>
                </div>
            }
        </div>
        }
    </div>
</div>

<ng-template #automatizeModal let-d="dismiss">
    <app-automatize-period
        [canRun]="!!openPeriod()"
        (ran)="onAutomatizeRan($event, d)"
        (dismiss)="d()" />
</ng-template>

<ng-template #previewDetail let-d="dismiss">
    <div class="modal-header border-bottom-0">
        <h5 class="modal-title fw-bold">Cerrar {{ periodLabel(periodClose) }} — {{ getMonthName(periodClose?.period) }}</h5>
        <button type="button" class="btn-close" (click)="d()"></button>
    </div>
    <div class="modal-body p-0">
        <div class="table-data px-4">
            <table class="table table-sm align-middle">
                <thead>
                    <tr class="text-muted small text-uppercase">
                        <th style="width: 5%">#</th>
                        <th>Entidad</th>
                        <th class="text-end">Cobros</th>
                    </tr>
                </thead>
                <tbody>
                    @if (isLoadingGen) {
                        @for (i of placeholderRows; track $index) {
                            <tr class="placeholder-glow">
                                <td><span class="placeholder placeholder-sm col-4 bg-gray-500"></span></td>
                                <td><span class="placeholder placeholder-sm col-10 bg-gray-500"></span></td>
                                <td class="text-end"><span class="placeholder placeholder-sm col-6 bg-gray-500"></span></td>
                            </tr>
                        }
                    } @else {
                        @for (r of generateCollectionsData; track $index; let i = $index) {
                            <tr>
                                <td>{{ i + 1 }}</td>
                                <td>{{ r.campus }} - <span class="text-muted">{{ r.entityCode }}</span></td>
                                <td class="text-end fw-bold" [ngClass]="{'text-danger': r.totalMonthlyContribution <= 0}">
                                    ${{ r.totalMonthlyContribution | number:'1.0-0' }}
                                </td>
                            </tr>
                        }
                    }
                </tbody>
                @if (generateCollectionsData.length > 0 && !isLoadingGen) {
                    <tfoot class="border-top">
                        <tr class="fw-bold">
                            <td></td>
                            <td>Total de cobros</td>
                            <td class="text-end">${{ totalPeriodContribution | number:'1.0-0' }}</td>
                        </tr>
                    </tfoot>
                }
            </table>
            @if (generateCollectionsData.length === 0 && !isLoadingGen) {
                <div class="text-center py-4 text-muted small">
                    <i class="fas fa-info-circle me-1"></i> No hay cobros para este periodo. Revisá socios y vehículos activos.
                </div>
            }
        </div>
    </div>
    <div class="modal-footer border-top-0 d-flex justify-content-between rounded-bottom">
        <div class="form-check form-switch small">
            <input class="form-check-input" type="checkbox" id="sendMail" [(ngModel)]="sendMailConfirm">
            <label class="form-check-label fw-bold text-muted" for="sendMail">Notificar a entidades por correo</label>
            @if (followingPeriod(periodClose); as next) {
                <p class="text-muted small mt-2 mb-0">
                    Al confirmar se envían los correos (si está marcado), se cierra el mes, se crea {{ periodLabel(next) }} y se generan sus cobros. Puede tardar unos minutos.
                </p>
            }
        </div>
        <div>
            <button type="button" class="btn btn-white btn-sm" (click)="d()" [disabled]="isClosing()">Cancelar</button>
            <button type="button"
                    class="btn btn-primary btn-sm ms-2"
                    [disabled]="isLoadingGen || isClosing() || generateCollectionsData.length === 0"
                    (click)="confirmClose()">
                Confirmar cierre
            </button>
        </div>
    </div>
</ng-template>
